const systemKeyPrefix = "_";

type SystemKey<Name extends string = string> =
  `${typeof systemKeyPrefix}${Name}`;

const makeSystemKey = <Name extends string>(name: Name): SystemKey<Name> =>
  `${systemKeyPrefix}${name}`;

export const recordSystemKeys = {
  first: makeSystemKey("first"),
  last: makeSystemKey("last"),
};

export const catalogRecordSystemKeys = {
  ...recordSystemKeys,
  classification: makeSystemKey("cls"),
};

export const classSystemKeys = {
  ...recordSystemKeys,
  secondParents: makeSystemKey("second_parents"),
  primarySpec: makeSystemKey("primSpec"),
  secondarySpecs: makeSystemKey("secondSpecs"),
};

const allSystemKeys = new Set<SystemKey>([
  ...Object.values(recordSystemKeys),
  ...Object.values(catalogRecordSystemKeys),
  ...Object.values(classSystemKeys),
]);

export const isSystemKey = (key: string): key is SystemKey =>
  allSystemKeys.has(key as SystemKey);
